import * as CONSTANTS from './constants';

export const setWorkspaceCompany = (id) => ({
  type: CONSTANTS.SET_WORKSPACE_COMPANY,
  id,
});

export const fetchPendingMemosRequest = (accountId) => ({
  type: CONSTANTS.FETCH_PENDING_MEMOS_REQUEST,
  accountId
});

export const fetchPendingMemosSuccess = (data) => ({
  type: CONSTANTS.FETCH_PENDING_MEMOS_SUCCESS,
  data,
});

export const fetchPendingMemosFail = (error) => ({
  type: CONSTANTS.FETCH_PENDING_MEMOS_FAIL,
  error
});

export const fetchAccountNetworkInvitationsRequest = (accountId, filter) => ({
  type: CONSTANTS.FETCH_ACCOUNT_NETWORK_INVITATIONS_REQUEST,
  accountId,
  filter
});

export const fetchAccountNetworkInvitationsSuccess = (data) => ({
  type: CONSTANTS.FETCH_ACCOUNT_NETWORK_INVITATIONS_SUCCESS,
  data,
});

export const fetchAccountNetworkInvitationsFail = (error) => ({
  type: CONSTANTS.FETCH_ACCOUNT_NETWORK_INVITATIONS_FAIL,
  error
});
